import { useEffect, useState } from "react";
import MemberLayout from "../components/MemberLayout";
import { api, formatDate } from "../lib/api";

export default function MemberProfile() {
  const [m, setM] = useState(null);
  useEffect(() => { api.get("/member/profile").then((r) => setM(r.data)); }, []);
  if (!m) return <MemberLayout><div className="text-brand-muted">Memuat…</div></MemberLayout>;

  return (
    <MemberLayout>
      <div className="space-y-5">
        <h1 className="font-heading font-extrabold text-3xl tracking-tight text-brand-ink">Profil Saya</h1>

        <div className="bg-white rounded-3xl border border-brand/10 shadow-sm p-5 flex flex-col sm:flex-row gap-5 items-start" data-testid="profile-card">
          {m.photo_selfie ? (
            <img src={m.photo_selfie} alt="profil" className="w-28 h-28 rounded-2xl object-cover border border-brand/15" />
          ) : (
            <div className="w-28 h-28 rounded-2xl bg-brand-soft flex items-center justify-center text-brand text-3xl font-heading font-bold">
              {m.full_name?.[0]?.toUpperCase() || "U"}
            </div>
          )}
          <div className="flex-1">
            <div className="font-heading font-bold text-xl text-brand-ink">{m.full_name}</div>
            <div className="text-sm text-brand-muted">{m.member_number || "Belum bernomor"} · {m.membership_type}</div>
            <div className="mt-3 grid grid-cols-2 gap-2 text-sm">
              <Info label="Email" value={m.email} />
              <Info label="No HP" value={m.phone} />
              <Info label="No KTP" value={m.ktp_no} />
              <Info label="No Rekening" value={m.account_no || "-"} />
              <Info label="Tempat Lahir" value={m.place_of_birth || "-"} />
              <Info label="Tgl Lahir" value={formatDate(m.date_of_birth)} />
              <Info label="Pekerjaan" value={m.occupation || "-"} />
              <Info label="Tanggal Daftar" value={formatDate(m.registered_at)} />
              <Info label="Alamat" value={m.address || "-"} className="col-span-2" />
            </div>
          </div>
        </div>

        {m.signature && (
          <div className="bg-white rounded-3xl border border-brand/10 shadow-sm p-5">
            <div className="text-xs uppercase tracking-[0.2em] text-brand-muted mb-2">Tanda Tangan</div>
            <img src={m.signature} alt="ttd" className="max-h-40 mx-auto" />
          </div>
        )}
      </div>
    </MemberLayout>
  );
}

function Info({ label, value, className = "" }) {
  return (
    <div className={"rounded-xl bg-brand-soft/40 px-3 py-2 " + className}>
      <div className="text-[10px] uppercase tracking-[0.18em] text-brand-muted">{label}</div>
      <div className="text-sm font-medium text-brand-ink break-words">{value || "-"}</div>
    </div>
  );
}
